module.exports = __webpack_public_path__ + "img/ftm.41283345.svg";